import StarFilled from '../../src/legacy/StarFilled';
export default StarFilled;
